module.exports = __webpack_public_path__ + "img/governorates.197c485d.svg";